import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Конфигурация для проверки файлов
export const FILE_CONFIG = {
  static: {
    formats: ["jpg", "png", "webp"],
    min_resolution: "600x600",
    recommended_resolution: "1080x1920",
    max_file_size_mb: 10
  },
  gif: {
    formats: ["gif"],
    min_resolution: "300x300",
    max_file_size_mb: 20
  },
  video: {
    formats: ["mp4"],
    recommended_resolution: "1080x1920",
    max_file_size_mb: 30,
    duration_max_sec: 60
  }
};

// Получаем все допустимые форматы
export const ALLOWED_FORMATS = [
  ...FILE_CONFIG.static.formats,
  ...FILE_CONFIG.gif.formats,
  ...FILE_CONFIG.video.formats
];

/**
 * Хук для валидации файлов
 * @returns {Object} Объект с функциями и состояниями для валидации файлов
 */
const useFileValidation = () => {
  const { t } = useTranslation();
  const [error, setError] = useState('');
  const [warning, setWarning] = useState('');

  /**
   * Валидация файла на соответствие требованиям
   * @param {File} file - Файл для валидации
   * @returns {boolean} Результат валидации
   */
  const validateFile = (file) => {
    setError('');
    setWarning('');
    
    // Получаем расширение файла
    const fileExtension = file.name.split('.').pop().toLowerCase();
    
    // Проверяем, является ли формат допустимым
    if (!ALLOWED_FORMATS.includes(fileExtension)) {
      setError(t('addPostcardModal.invalidFileType', { 
        formats: ALLOWED_FORMATS.join(', ') 
      }));
      return false;
    }
    
    // Проверяем размер файла
    const fileSizeMB = file.size / (1024 * 1024);
    let maxSizeMB = 10; // По умолчанию
    
    // Определяем максимальный размер в зависимости от типа файла
    if (FILE_CONFIG.static.formats.includes(fileExtension)) {
      maxSizeMB = FILE_CONFIG.static.max_file_size_mb;
    } else if (FILE_CONFIG.gif.formats.includes(fileExtension)) {
      maxSizeMB = FILE_CONFIG.gif.max_file_size_mb;
    } else if (FILE_CONFIG.video.formats.includes(fileExtension)) {
      maxSizeMB = FILE_CONFIG.video.max_file_size_mb;
    }
    
    if (fileSizeMB > maxSizeMB) {
      setError(t('addPostcardModal.fileTooLarge', { 
        maxSize: maxSizeMB,
        currentSize: fileSizeMB.toFixed(1)
      }));
      return false;
    }
    
    // TODO: Добавить проверку разрешения для изображений
    // TODO: Добавить проверку длительности для видео
    // TODO: Реализовать с использованием FileReader и т.д.
    
    return true;
  };

  return {
    error,
    warning,
    setError,
    setWarning,
    validateFile,
    ALLOWED_FORMATS
  };
};

export default useFileValidation; 